<script>

export default {
  props: ['item'],
  data() {
    return {
      dsbl_btn: false,

      loading_mlss: true,
      mlss: [],
      temp_mls: {},

    }
  },
  created() {
    if(this.item.mls) { this.temp_mls = this.item.mls; }
    this.fetch_mlss();
  },
  methods: {
    fetch_mlss() {
      this.loading_mlss = true;
      this.$http.get('/api/mlss/fetch', {params:{paginate:1000, page:1, total:0, selects:['id','title','office_name']}}).then(res => {
        // console.log(res);
        this.mlss = res.data.data;
        this.loading_mlss = false;
      }).catch(res => { this.loading_mlss = false; this.popupErrors(res); });
    },
    update_listing() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/listings/update', {id: this.item.id, mls_id: this.temp_mls.id}).then(res => {
        console.log(res);
        if(res.data && res.data.mls) {
          this.item.mls_id = res.data.mls.id;
          this.item.mls = res.data.mls;
        } else {
          this.item.mls_id = null;
          this.item.mls = null;
        }
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div>
    <div class="p-3">
      <h5 class="section-header mb-3">
      <i class="spinner-border spinner-border-sm" v-if="loading_mlss"></i><Icon v-else icon="ri:book-2-line"></Icon> Assigned MLS
    </h5>
    <p class="text-muted small mb-3">Assign to a specific MLS. This will change the clients form data questions to the selected MLS.</p>
    <div v-if="!loading_mlss" class="row">
      <div class="col-sm-12 mb-2">
        <multiselect id="input-lead_recipients" v-model="temp_mls" :options="mlss" :preserve-search="true" placeholder="Select..." label="name" track-by="id" required>
          <template slot="singleLabel" slot-scope="props">{{props.option.title}} <span class="text-muted">({{props.option.office_name}})</span></template>
          <template slot="option" slot-scope="props">{{props.option.title}} <span class="text-muted">({{props.option.office_name}})</span></template>
        </multiselect>
      </div>
    </div>
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn btn-light" @click="$emit('hidemodel')" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
      <button type="button" class="btn btn-primary" @click="update_listing()" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
    </footer>
  </div>
</template>
